var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderarrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.03 82.3539C123.03 104.846 104.846 123.031 82.3538 123.03C59.8616 123.03 41.6769 104.846 41.6768 82.3535C41.6767 59.8613 59.8612 41.6768 82.3534 41.6769C104.846 41.677 123.03 59.8617 123.03 82.3539Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.274 81.5059L80.7795 105.001L77.3884 101.61L97.4923 81.5058L77.3882 61.4018L80.7792 58.0108L104.274 81.5059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7063 83.9279L59.7063 79.0835L100.883 79.0837L100.883 83.9281L59.7063 83.9279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderarrowright);
export default __webpack_public_path__ + "static/media/Sliderarrowright.8c446bde26c7c0f6042adef2a029e6a0.svg";
export { ForwardRef as ReactComponent };